import React from 'react';
import { createIcon } from '@chakra-ui/icons';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ChevronDown = createIcon({
  displayName: 'ChevronDown',
  viewBox: '0 0 24 24',
  path: ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M12 16l-6-6h12l-6 6z"
  })
});
export var ChevronDownThin = createIcon({
  displayName: 'ChevronDownThin',
  viewBox: '0 0 24 24',
  path: ___EmotionJSX("path", {
    d: "M12.002 13.0543L14.1953 10.861C14.4553 10.601 14.8753 10.601 15.1353 10.861C15.3953 11.121 15.3953 11.541 15.1353 11.801L12.4687 14.4677C12.2087 14.7277 11.7887 14.7277 11.5287 14.4677L8.86199 11.801C8.60199 11.541 8.60199 11.121 8.86199 10.861C9.12199 10.601 9.54199 10.601 9.80199 10.861L12.002 13.0543Z",
    fill: "#8298A1"
  })
});
export var IconAddPhotos = createIcon({
  displayName: 'IconAddPhotos',
  viewBox: '0 0 24 24',
  path: ___EmotionJSX(React.Fragment, null, ___EmotionJSX("path", {
    d: "M18 11.025V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.025A5.499 5.499 0 1 0 18 11.025",
    fill: "#F7F7F7"
  }), ",", ___EmotionJSX("path", {
    d: "M17.52 21A4.525 4.525 0 0 1 13 16.48a4.525 4.525 0 0 1 4.52-4.521 4.525 4.525 0 0 1 4.52 4.521A4.525 4.525 0 0 1 17.52 21zM3 4h14v6.985A5.518 5.518 0 0 0 12.024 16H3V4zm15 6.983V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.026A5.519 5.519 0 1 0 18 10.983z",
    fill: "#9FB0B7"
  }), ",", ___EmotionJSX("path", {
    d: "M19.5 16H18v-1.5a.5.5 0 0 0-1 0V16h-1.5a.5.5 0 0 0 0 1H17v1.5a.5.5 0 0 0 1 0V17h1.5a.5.5 0 0 0 0-1M12 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0M11 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0M8 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    fill: "#9FB0B7"
  }))
});
export var IconMoreTools = createIcon({
  displayName: 'IconMoreTools',
  viewBox: '0 0 24 24',
  path: ___EmotionJSX("g", {
    fill: "none",
    fillRule: "evenodd"
  }, ___EmotionJSX("path", {
    d: "M18 11.025V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.025A5.499 5.499 0 1 0 18 11.025",
    fill: "#F7F7F7"
  }), ___EmotionJSX("path", {
    d: "M17.5 21a4.505 4.505 0 0 1-4.5-4.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zM7.061 10.354a1.502 1.502 0 0 0-2.122 0L3 12.293V4h14v7.025a5.502 5.502 0 0 0-4.89 4.376l-5.049-5.047zM3 16v-2.293l2.646-2.646a.5.5 0 0 1 .708 0L11.293 16H3zm15-4.975V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.025A5.499 5.499 0 1 0 18 11.025z",
    fill: "#9FB0B7"
  }), ___EmotionJSX("path", {
    d: "M19.5 16H18v-1.5a.5.5 0 0 0-1 0V16h-1.5a.5.5 0 0 0 0 1H17v1.5a.5.5 0 0 0 1 0V17h1.5a.5.5 0 0 0 0-1M13 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m3-2a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
    fill: "#9FB0B7"
  }))
});